module.exports = __webpack_public_path__ + "static/media/evaluationCriteria.4d0ac5a8.pdf";